import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getBibliotecasAvatares,
  getBibliotecasAvataresById,
  insertBibliotecaAvatares,
  updateBibliotecaAvatares,
  deleteBibliotecaAvatares,
  getBibliotecasAvataresSecciones,
  getBibliotecasAvataresSeccionById,
  insertBibliotecaAvataresSeccion,
  updateBibliotecaAvataresSeccion,
  deleteBibliotecaAvataresSeccion,
  updateBibliotecaAvataresSeccionOrder,
  getBibliotecasAvataresSizes,
  getBibliotecasAvataresSizeById,
  insertBibliotecaAvataresSize,
  updateBibliotecaAvataresSize,
  deleteBibliotecaAvataresSize,
  getBibliotecaAvataresClienteResume,
  getBibliotecaAvataresClienteAdmin,
  getBibliotecaAvataresGaleria,
  getBibliotecasAvataresObjetoById,
  getBibliotecasAvataresPaletas,
  getBibliotecasAvataresPaletaById,
  insertBibliotecaAvataresPaleta,
  updateBibliotecaAvataresPaleta,
  deleteBibliotecaAvataresPaleta,
  getBibliotecasAvataresObjetoVarianteById,
  updateBibliotecaAvataresObjetoVariante,
  updateBibliotecaAvataresCacheCliente,
  updateBibliotecaAvataresCacheAdmin,
  updateBibliotecaAvataresCacheFamilias,
  updateBibliotecaAvataresCacheProductos,
  updateBibliotecaAvataresCachePaises,
  updateBibliotecaAvataresCacheProvincias,
  insertMasivoGaleria,
  confirmMasivoGaleria,
  insertImageGaleria,
  getBibliotecasAvataresPlantillas,
  getBibliotecasAvataresPlantillaById,
  insertBibliotecaAvataresPlantilla,
  updateBibliotecaAvataresPlantilla,
  deleteBibliotecaAvataresPlantilla,
  getBibliotecasAvataresPlantillaObjetoById,
  getBibliotecasAvataresPlantillaObjetos,
  getBibliotecasAvataresLayers,
  getBibliotecasAvataresLayerById,
  insertBibliotecaAvataresLayer,
  updateBibliotecaAvataresLayer,
  deleteBibliotecaAvataresLayer,
  getBibliotecasAvataresColor,
  insertBibliotecaAvataresColor,
  updateBibliotecaAvataresColor,
  deleteBibliotecaAvataresColor,
  updateBibliotecaAvataresColorOrder,
  duplicarBibliotecaAvataresPaleta,
  getBibliotecasAvataresProdById,
  getBibliotecasAvataresPiezas,
  getBibliotecasAvataresPiezaById,
  insertBibliotecaAvataresPieza,
  updateBibliotecaAvataresPieza,
  deleteBibliotecaAvataresPieza,
  updateBibliotecaAvataresObjeto,
  insertObjectMiniatura,
  deleteObjectMiniatura,
  insertObjectImpresion,
  deleteObjectImpresion,
  insertObjectVariante,
  deleteObjectVariante,
  updateObjectVarianteSize,
  getBibliotecasAvataresObjetoUnicoById,
  updateBibliotecaAvataresObjetoUnico,
  getBibliotecasAvataresSizesFam,
  getBibliotecasAvataresModeloById,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'
import history from '../../history'
import { getBibliotecaAvataresClienteEmailAdmin } from '../../services/personalizacion'

export function* GET_BIBAVATARES() {
  try {
    const bibliotecasAvataresData = yield call(getBibliotecasAvatares)
    if (bibliotecasAvataresData.ok) {
      yield put({
        type: actions.BIBAVATARES_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Avatares')
      put({
        type: actions.BIBAVATARES_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_BY_ID(action) {
  try {
    const bibliotecasAvataresData = yield call(getBibliotecasAvataresById, action.payload)
    if (bibliotecasAvataresData.ok) {
      yield put({
        type: actions.BIBAVATARES_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Avatares')
      put({
        type: actions.BIBAVATARES_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES(action) {
  try {
    const bibAvatares = yield call(insertBibliotecaAvatares, action.payload)
    if (bibAvatares.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Avatares creada correctamente')
      history.push(`/avatares/edit/${bibAvatares.data.id}`)
    } else {
      putMessage(messageType.ERROR, 'Error al crear Biblioteca de Avatares')
      yield put({
        type: actions.BIBAVATARES_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Biblioteca de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES(action) {
  try {
    const bibAvatares = yield call(updateBibliotecaAvatares, action.payload)
    if (bibAvatares.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Avatares modificada correctamente')
      yield put({
        type: actions.BIBAVATARES_UPDATE_SUCCEEDED,
        payload: bibAvatares.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Avatares')
      yield put({
        type: actions.BIBAVATARES_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES(action) {
  try {
    const bibAvatares = yield call(deleteBibliotecaAvatares, action.payload)
    if (bibAvatares.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Avatares eliminada correctamente')
      yield put({
        type: actions.DELETE_BIBAVATARES_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Avatares')
      put({
        type: actions.DELETE_BIBAVATARES_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Avatares')
    yield all([
      put({
        type: actions.DELETE_BIBAVATARES_FAILED,
        error: e.message,
      }),
    ])
  }
}

// Modelo
export function* GET_BIBAVATARES_MODELO_BY_ID(action) {
  try {
    const bibliotecasAvataresModeloData = yield call(
      getBibliotecasAvataresModeloById,
      action.payload,
    )
    if (bibliotecasAvataresModeloData.ok) {
      yield put({
        type: actions.BIBAVATARES_MODELO_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresModeloData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Modelo')
      put({
        type: actions.BIBAVATARES_MODELO_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Modelo')
    yield all([
      put({
        type: actions.BIBAVATARES_MODELO_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

// Secciones
export function* GET_BIBAVATARES_SECCION() {
  try {
    const bibliotecasAvataresSeccionData = yield call(getBibliotecasAvataresSecciones)
    if (bibliotecasAvataresSeccionData.ok) {
      yield put({
        type: actions.BIBAVATARES_SECCION_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresSeccionData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca Secciones de Avatares')
      put({
        type: actions.BIBAVATARES_SECCION_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca Secciones de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_SECCION_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_SECCION_BY_ID(action) {
  try {
    const bibliotecasAvataresSeccionData = yield call(
      getBibliotecasAvataresSeccionById,
      action.payload,
    )
    if (bibliotecasAvataresSeccionData.ok) {
      yield put({
        type: actions.BIBAVATARES_SECCION_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresSeccionData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca Sección de Avatares')
      put({
        type: actions.BIBAVATARES_SECCION_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca Sección de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_SECCION_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_SECCION(action) {
  try {
    const bibAvataresSeccion = yield call(insertBibliotecaAvataresSeccion, action.payload)
    if (bibAvataresSeccion.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca Sección de Avatares creada correctamente')
      history.push(`/avatares/seccion/edit/${bibAvataresSeccion.data.id}`)
    } else {
      putMessage(messageType.ERROR, 'Error al crear Biblioteca Sección de Avatares')
      yield put({
        type: actions.BIBAVATARES_SECCION_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Biblioteca Sección de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_SECCION_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_SECCION(action) {
  try {
    const bibAvataresSeccion = yield call(updateBibliotecaAvataresSeccion, action.payload)
    if (bibAvataresSeccion.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca Sección de Avatares modificada correctamente')
      yield put({
        type: actions.BIBAVATARES_SECCION_UPDATE_SUCCEEDED,
        payload: bibAvataresSeccion.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Biblioteca Sección de Avatares')
      yield put({
        type: actions.BIBAVATARES_SECCION_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca Sección de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_SECCION_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_SECCION(action) {
  try {
    const bibAvataresSeccion = yield call(deleteBibliotecaAvataresSeccion, action.payload)
    if (bibAvataresSeccion.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca Sección de Avatares eliminada correctamente')
      yield put({
        type: actions.DELETE_BIBAVATARES_SECCION_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca Sección de Avatares')
      put({
        type: actions.DELETE_BIBAVATARES_SECCION_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca Sección de Avatares')
    yield all([
      put({
        type: actions.DELETE_BIBAVATARES_SECCION_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_SECCION_ORDER(action) {
  try {
    const dataResult = yield call(updateBibliotecaAvataresSeccionOrder, action.payload)
    if (dataResult.ok) {
      putMessage(messageType.SUCCESS, 'Orden de la sección modificada correctamente')
      yield put({
        type: actions.BIBAVATARES_SECCION_UPDATE_ORDER_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el orden de la sección')
      yield put({
        type: actions.BIBAVATARES_SECCION_UPDATE_ORDER_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el orden de la sección')
    yield all([
      put({
        type: actions.BIBAVATARES_SECCION_UPDATE_ORDER_FAILED,
        error: e.message,
      }),
    ])
  }
}
// Paletas
export function* GET_BIBAVATARES_PALETA(action) {
  try {
    const bibliotecasAvataresPaletaData = yield call(getBibliotecasAvataresPaletas, action.payload)
    if (bibliotecasAvataresPaletaData.ok) {
      yield put({
        type: actions.BIBAVATARES_PALETA_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresPaletaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Paletas')
      put({
        type: actions.BIBAVATARES_PALETA_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Paletas')
    yield all([
      put({
        type: actions.BIBAVATARES_PALETA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_PALETA_BY_ID(action) {
  try {
    const bibliotecasAvataresPaletaData = yield call(
      getBibliotecasAvataresPaletaById,
      action.payload,
    )
    if (bibliotecasAvataresPaletaData.ok) {
      yield put({
        type: actions.BIBAVATARES_PALETA_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresPaletaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Paletas')
      put({
        type: actions.BIBAVATARES_PALETA_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Paletas')
    yield all([
      put({
        type: actions.BIBAVATARES_PALETA_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_PALETA(action) {
  try {
    const bibAvataresPaleta = yield call(insertBibliotecaAvataresPaleta, action.payload)
    if (bibAvataresPaleta.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Paletas creada correctamente')
      yield put({
        type: actions.BIBAVATARES_PALETA_INSERT_SUCCEEDED,
        payload: bibAvataresPaleta.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear la Biblioteca de Paletas')
      yield put({
        type: actions.BIBAVATARES_PALETA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear la Biblioteca de Paletas')
    yield all([
      put({
        type: actions.BIBAVATARES_PALETA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_PALETA(action) {
  try {
    const bibAvataresPaleta = yield call(updateBibliotecaAvataresPaleta, action.payload)
    if (bibAvataresPaleta.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Paletas modificada correctamente')
      yield put({
        type: actions.BIBAVATARES_PALETA_UPDATE_SUCCEEDED,
        payload: bibAvataresPaleta.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar la Biblioteca de Paletas')
      yield put({
        type: actions.BIBAVATARES_PALETA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar la Biblioteca de Paletas')
    yield all([
      put({
        type: actions.BIBAVATARES_PALETA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DUPLICAR_BIBAVATARES_PALETA(action) {
  try {
    const bibAvataresPaleta = yield call(duplicarBibliotecaAvataresPaleta, action.payload)
    if (bibAvataresPaleta.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Paletas duplicada correctamente')
      yield put({
        type: actions.BIBAVATARES_PALETA_DUPLICAR_SUCCEEDED,
        payload: bibAvataresPaleta.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al duplicar la Biblioteca de Paletas')
      yield put({
        type: actions.BIBAVATARES_PALETA_DUPLICAR_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al duplicar la Biblioteca de Paletas')
    yield all([
      put({
        type: actions.BIBAVATARES_PALETA_DUPLICAR_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_PALETA(action) {
  try {
    const bibAvataresPaleta = yield call(deleteBibliotecaAvataresPaleta, action.payload)
    if (bibAvataresPaleta.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Paletas eliminada correctamente')
      yield put({
        type: actions.DELETE_BIBAVATARES_PALETA_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Paletas')
      put({
        type: actions.DELETE_BIBAVATARES_PALETA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Paletas')
    yield all([
      put({
        type: actions.DELETE_BIBAVATARES_PALETA_FAILED,
        error: e.message,
      }),
    ])
  }
}

// Tamaños
export function* GET_BIBAVATARES_SIZE() {
  try {
    const bibliotecasAvataresSizeData = yield call(getBibliotecasAvataresSizes)
    if (bibliotecasAvataresSizeData.ok) {
      yield put({
        type: actions.BIBAVATARES_SIZE_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresSizeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Tamaños de Avatares')
      put({
        type: actions.BIBAVATARES_SIZE_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Tamaños de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_SIZE_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_SIZEFAM() {
  try {
    const bibliotecasAvataresSizeData = yield call(getBibliotecasAvataresSizesFam)
    if (bibliotecasAvataresSizeData.ok) {
      yield put({
        type: actions.BIBAVATARES_SIZE_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresSizeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Tamaños de Avatares')
      put({
        type: actions.BIBAVATARES_SIZE_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Tamaños de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_SIZE_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_SIZE_BY_ID(action) {
  try {
    const bibliotecasAvataresSizeData = yield call(getBibliotecasAvataresSizeById, action.payload)
    if (bibliotecasAvataresSizeData.ok) {
      yield put({
        type: actions.BIBAVATARES_SIZE_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresSizeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Tamaño de Avatares')
      put({
        type: actions.BIBAVATARES_SIZE_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Tamaño de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_SIZE_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_SIZE(action) {
  try {
    const bibAvataresSize = yield call(insertBibliotecaAvataresSize, action.payload)
    if (bibAvataresSize.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Tamaño de Avatares creada correctamente')
      yield put({
        type: actions.BIBAVATARES_SIZE_UPDATE_SUCCEEDED,
        payload: bibAvataresSize.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Biblioteca de Tamaño de Avatares')
      yield put({
        type: actions.BIBAVATARES_SIZE_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Biblioteca de Tamaño de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_SIZE_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_SIZE(action) {
  try {
    const bibAvataresSize = yield call(updateBibliotecaAvataresSize, action.payload)
    if (bibAvataresSize.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Tamaño de Avatares modificada correctamente')
      yield put({
        type: actions.BIBAVATARES_SIZE_UPDATE_SUCCEEDED,
        payload: bibAvataresSize.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Tamaño de Avatares')
      yield put({
        type: actions.BIBAVATARES_SIZE_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Tamaño de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_SIZE_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_SIZE(action) {
  try {
    const bibAvataresSize = yield call(deleteBibliotecaAvataresSize, action.payload)
    if (bibAvataresSize.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca Tamaño de Avatares eliminada correctamente')
      yield put({
        type: actions.DELETE_BIBAVATARES_SIZE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca Tamaño de Avatares')
      put({
        type: actions.DELETE_BIBAVATARES_SIZE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca Tamaño de Avatares')
    yield all([
      put({
        type: actions.DELETE_BIBAVATARES_SIZE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_CLIENTE_RESUME(action) {
  try {
    const bibliotecasAvataresClienteResumeData = yield call(
      getBibliotecaAvataresClienteResume,
      action.payload,
    )
    if (bibliotecasAvataresClienteResumeData.ok) {
      yield put({
        type: actions.BIBAVATARES_CLIENTE_RESUME_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresClienteResumeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar el Resumen de Avatares de Cliente')
      put({
        type: actions.BIBAVATARES_CLIENTE_RESUME_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar el Resumen de Avatares de Cliente')
    yield all([
      put({
        type: actions.BIBAVATARES_CLIENTE_RESUME_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_CLIENTE_ADMIN(action) {
  try {
    const bibliotecasAvataresClienteAdminData = yield call(
      getBibliotecaAvataresClienteAdmin,
      action.payload,
    )
    if (bibliotecasAvataresClienteAdminData.ok) {
      yield put({
        type: actions.BIBAVATARES_CLIENTE_ADMIN_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresClienteAdminData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Avatares de Cliente')
      put({
        type: actions.BIBAVATARES_CLIENTE_ADMIN_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar los Avatares de Cliente')
    yield all([
      put({
        type: actions.BIBAVATARES_CLIENTE_ADMIN_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_CLIENTE_EMAIL_ADMIN(action) {
  try {
    const bibliotecasAvataresClienteAdminData = yield call(
      getBibliotecaAvataresClienteEmailAdmin,
      action.payload,
    )
    if (bibliotecasAvataresClienteAdminData.ok) {
      yield put({
        type: actions.BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresClienteAdminData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Avatares de Cliente')
      put({
        type: actions.BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar los Avatares de Cliente')
    yield all([
      put({
        type: actions.BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_GALERIA(action) {
  try {
    const bibliotecasAvataresSizeData = yield call(getBibliotecaAvataresGaleria, action.payload)
    if (bibliotecasAvataresSizeData.ok) {
      yield put({
        type: actions.BIBAVATARES_GALERIA_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresSizeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Tamaño de Avatares')
      put({
        type: actions.BIBAVATARES_GALERIA_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Galería de Familia')
    yield all([
      put({
        type: actions.BIBAVATARES_GALERIA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_OBJETO_BY_ID(action) {
  try {
    const bibliotecasAvataresObjetoData = yield call(
      getBibliotecasAvataresObjetoById,
      action.payload,
    )
    if (bibliotecasAvataresObjetoData.ok) {
      yield put({
        type: actions.BIBAVATARES_OBJETO_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresObjetoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la información del Objeto')
      put({
        type: actions.BIBAVATARES_OBJETO_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar la información del Objeto')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_OBJETO_UNICO_BY_ID(action) {
  try {
    const bibliotecasAvataresObjetoUnicoData = yield call(
      getBibliotecasAvataresObjetoUnicoById,
      action.payload,
    )
    if (bibliotecasAvataresObjetoUnicoData.ok) {
      yield put({
        type: actions.BIBAVATARES_OBJETO_UNICO_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresObjetoUnicoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la información del Objeto Único')
      put({
        type: actions.BIBAVATARES_OBJETO_UNICO_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar la información del Objeto Único')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_UNICO_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_OBJETO_UNICO(action) {
  try {
    const bibAvataresObjetoVar = yield call(updateBibliotecaAvataresObjetoUnico, action.payload)
    if (bibAvataresObjetoVar.ok) {
      putMessage(messageType.SUCCESS, 'Carga de objeto único procesada correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_UNICO_UPDATE_SUCCEEDED,
        payload: bibAvataresObjetoVar.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al procesar la carga de objeto único')
      yield put({
        type: actions.BIBAVATARES_OBJETO_UNICO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al procesar la carga de objeto único')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_UNICO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_OBJETO_VARIANTE_BY_ID(action) {
  try {
    const bibliotecasAvataresObjetoVarData = yield call(
      getBibliotecasAvataresObjetoVarianteById,
      action.payload,
    )
    if (bibliotecasAvataresObjetoVarData.ok) {
      yield put({
        type: actions.BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresObjetoVarData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la información del Objeto')
      put({
        type: actions.BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar la información del Objeto')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_OBJETO(action) {
  try {
    const bibAvataresObjeto = yield call(updateBibliotecaAvataresObjeto, action.payload)
    if (bibAvataresObjeto.ok) {
      putMessage(messageType.SUCCESS, 'Objeto de Avatar modificado correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_UPDATE_SUCCEEDED,
        payload: bibAvataresObjeto.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el Objeto de Avatar')
      yield put({
        type: actions.BIBAVATARES_OBJETO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el Objeto de Avatar')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_OBJETO_MINIATURA(action) {
  try {
    const bibAvataresObjetoMin = yield call(insertObjectMiniatura, action.payload)
    if (bibAvataresObjetoMin.ok) {
      putMessage(messageType.SUCCESS, 'Carga de imagen de miniatura procesada correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_INSERT_MINIATURA_SUCCEEDED,
        payload: bibAvataresObjetoMin.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al procesar la carga de imagen de miniatura')
      yield put({
        type: actions.BIBAVATARES_OBJETO_INSERT_MINIATURA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al procesar la carga de imagen de miniatura')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_INSERT_MINIATURA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_OBJETO_MINIATURA(action) {
  try {
    const bibAvataresObjetoMin = yield call(deleteObjectMiniatura, action.payload)
    if (bibAvataresObjetoMin.ok) {
      putMessage(messageType.SUCCESS, 'Miniatura de Avatares eliminada correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_DELETE_MINIATURA_SUCCEEDED,
        payload: bibAvataresObjetoMin.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Miniatura de Avatares')
      put({
        type: actions.BIBAVATARES_OBJETO_DELETE_MINIATURA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Miniatura de Avatares')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_DELETE_MINIATURA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_OBJETO_IMPRESION(action) {
  try {
    const bibAvataresObjetoPrint = yield call(insertObjectImpresion, action.payload)
    if (bibAvataresObjetoPrint.ok) {
      putMessage(messageType.SUCCESS, 'Carga de svg de impresion procesada correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_INSERT_IMPRESION_SUCCEEDED,
        payload: bibAvataresObjetoPrint.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al procesar la carga de svg de impresion')
      yield put({
        type: actions.BIBAVATARES_OBJETO_INSERT_IMPRESION_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al procesar la carga de svg de impresion')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_INSERT_IMPRESION_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_OBJETO_IMPRESION(action) {
  try {
    const bibAvataresObjetoPrint = yield call(deleteObjectImpresion, action.payload)
    if (bibAvataresObjetoPrint.ok) {
      putMessage(messageType.SUCCESS, 'SVG de impresión eliminado correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_DELETE_IMPRESION_SUCCEEDED,
        payload: bibAvataresObjetoPrint.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar el SVG de impresión')
      put({
        type: actions.BIBAVATARES_OBJETO_DELETE_IMPRESION_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar el SVG de impresión')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_DELETE_IMPRESION_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_OBJETO_VARIANTE(action) {
  try {
    const bibAvataresObjetoVar = yield call(insertObjectVariante, action.payload)
    if (bibAvataresObjetoVar.ok) {
      putMessage(messageType.SUCCESS, 'Carga de variante procesada correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_INSERT_VARIANTE_SUCCEEDED,
        payload: bibAvataresObjetoVar.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al procesar la carga de variante')
      yield put({
        type: actions.BIBAVATARES_OBJETO_INSERT_VARIANTE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al procesar la carga de variante')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_INSERT_VARIANTE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_OBJETO_VARIANTE_SIZE(action) {
  try {
    const bibAvataresObjetoVar = yield call(updateObjectVarianteSize, action.payload)
    if (bibAvataresObjetoVar.ok) {
      putMessage(messageType.SUCCESS, 'Carga de variante procesada correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_VARIANTE_SIZE_SUCCEEDED,
        payload: bibAvataresObjetoVar.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al procesar la carga de variante')
      yield put({
        type: actions.BIBAVATARES_OBJETO_VARIANTE_SIZE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al procesar la carga de variante')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_VARIANTE_SIZE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_OBJETO_VARIANTE(action) {
  try {
    const bibAvataresObjetoVar = yield call(deleteObjectVariante, action.payload)
    if (bibAvataresObjetoVar.ok) {
      putMessage(messageType.SUCCESS, 'Variante de Objeto eliminada correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_DELETE_VARIANTE_SUCCEEDED,
        payload: bibAvataresObjetoVar.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Variante del Objeto')
      put({
        type: actions.BIBAVATARES_OBJETO_DELETE_VARIANTE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Variante del Objeto')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_DELETE_VARIANTE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_OBJETO_VARIANTE(action) {
  try {
    const bibAvataresObjetoVar = yield call(updateBibliotecaAvataresObjetoVariante, action.payload)
    if (bibAvataresObjetoVar.ok) {
      putMessage(messageType.SUCCESS, 'Objeto de Avatar modificado correctamente')
      yield put({
        type: actions.BIBAVATARES_OBJETO_VARIANTE_UPDATE_SUCCEEDED,
        payload: bibAvataresObjetoVar.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el Objeto de Avatar')
      yield put({
        type: actions.BIBAVATARES_OBJETO_VARIANTE_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el Objeto de Avatar')
    yield all([
      put({
        type: actions.BIBAVATARES_OBJETO_VARIANTE_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_CACHE_CLIENTE(action) {
  try {
    const bibAvataresObjetoCache = yield call(updateBibliotecaAvataresCacheCliente, action.payload)
    if (bibAvataresObjetoCache.ok) {
      putMessage(messageType.SUCCESS, 'Caché de Cliente actualizada correctamente')
      yield put({
        type: actions.BIBAVATARES_CACHE_CLIENTE_UPDATE_SUCCEEDED,
        payload: bibAvataresObjetoCache.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar la Caché de Cliente')
      yield put({
        type: actions.BIBAVATARES_CACHE_CLIENTE_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al actualizar la Caché de Cliente')
    yield all([
      put({
        type: actions.BIBAVATARES_CACHE_CLIENTE_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_CACHE_ADMIN(action) {
  try {
    const bibAvataresObjetoCache = yield call(updateBibliotecaAvataresCacheAdmin, action.payload)
    if (bibAvataresObjetoCache.ok) {
      putMessage(messageType.SUCCESS, 'Caché de Admin actualizada correctamente')
      yield put({
        type: actions.BIBAVATARES_CACHE_ADMIN_UPDATE_SUCCEEDED,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar la Caché de Admin')
      yield put({
        type: actions.BIBAVATARES_CACHE_ADMIN_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al actualizar la Caché de Admin')
    yield all([
      put({
        type: actions.BIBAVATARES_CACHE_ADMIN_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_CACHE_FAMILIAS(action) {
  try {
    const bibAvataresObjetoCache = yield call(updateBibliotecaAvataresCacheFamilias, action.payload)
    if (bibAvataresObjetoCache.ok) {
      putMessage(messageType.SUCCESS, 'Caché de Familias actualizada correctamente')
      yield put({
        type: actions.BIBAVATARES_CACHE_FAMILIAS_UPDATE_SUCCEEDED,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar la Caché de Familias')
      yield put({
        type: actions.BIBAVATARES_CACHE_FAMILIAS_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al actualizar la Caché de Familias')
    yield all([
      put({
        type: actions.BIBAVATARES_CACHE_FAMILIAS_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_CACHE_PRODUCTOS(action) {
  try {
    const bibAvataresObjetoCache = yield call(
      updateBibliotecaAvataresCacheProductos,
      action.payload,
    )
    if (bibAvataresObjetoCache.ok) {
      putMessage(messageType.SUCCESS, 'Caché de Productos actualizada correctamente')
      yield put({
        type: actions.BIBAVATARES_CACHE_PRODUCTOS_UPDATE_SUCCEEDED,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar la Caché de Productos')
      yield put({
        type: actions.BIBAVATARES_CACHE_PRODUCTOS_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al actualizar la Caché de Productos')
    yield all([
      put({
        type: actions.BIBAVATARES_CACHE_PRODUCTOS_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_CACHE_PAISES(action) {
  try {
    const bibAvataresObjetoCache = yield call(updateBibliotecaAvataresCachePaises, action.payload)
    if (bibAvataresObjetoCache.ok) {
      putMessage(messageType.SUCCESS, 'Caché de Paises actualizada correctamente')
      yield put({
        type: actions.BIBAVATARES_CACHE_PAISES_UPDATE_SUCCEEDED,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar la Caché de Paises')
      yield put({
        type: actions.BIBAVATARES_CACHE_PAISES_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al actualizar la Caché de Paises')
    yield all([
      put({
        type: actions.BIBAVATARES_CACHE_PAISES_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_CACHE_PROVINCIAS(action) {
  try {
    const bibAvataresObjetoCache = yield call(
      updateBibliotecaAvataresCacheProvincias,
      action.payload,
    )
    if (bibAvataresObjetoCache.ok) {
      putMessage(messageType.SUCCESS, 'Caché de Provincias actualizada correctamente')
      yield put({
        type: actions.BIBAVATARES_CACHE_PROVINCIAS_UPDATE_SUCCEEDED,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar la Caché de Provincias')
      yield put({
        type: actions.BIBAVATARES_CACHE_PROVINCIAS_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al actualizar la Caché de Provincias')
    yield all([
      put({
        type: actions.BIBAVATARES_CACHE_PROVINCIAS_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPLOAD_BIBAVATARES_GALERIA_MASIVO(action) {
  try {
    const bibAvataresObjetoVar = yield call(insertMasivoGaleria, action.payload)
    if (bibAvataresObjetoVar.ok) {
      putMessage(messageType.SUCCESS, 'Carga masiva de Avatar procesada correctamente')
      yield put({
        type: actions.BIBAVATARES_GALERIA_MASIVO_SUCCEEDED,
        payload: bibAvataresObjetoVar.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al procesar la carga masiva de Avatar')
      yield put({
        type: actions.BIBAVATARES_GALERIA_MASIVO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al procesar la carga masiva de Avatar')
    yield all([
      put({
        type: actions.BIBAVATARES_GALERIA_MASIVO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* CONFIRM_BIBAVATARES_GALERIA_MASIVO(action) {
  try {
    const bibAvataresObjetoVar = yield call(confirmMasivoGaleria, action.payload)
    if (bibAvataresObjetoVar.ok) {
      putMessage(messageType.SUCCESS, 'Carga masiva de Avatar confirmada correctamente')
      yield put({
        type: actions.BIBAVATARES_GALERIA_CONFIRM_MASIVO_SUCCEEDED,
      })
      history.push(`/avatares/galeria/list/${action.payload.data.familiaId}`)
    } else {
      putMessage(messageType.ERROR, 'Error al confirmar la carga masiva de Avatar')
      yield put({
        type: actions.BIBAVATARES_GALERIA_CONFIRM_MASIVO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al confirmar la carga masiva de Avatar')
    yield all([
      put({
        type: actions.BIBAVATARES_GALERIA_CONFIRM_MASIVO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_GALERIA_FILE(action) {
  try {
    const bibAvataresObjetoVar = yield call(insertImageGaleria, action.payload)
    if (bibAvataresObjetoVar.ok) {
      putMessage(messageType.SUCCESS, 'Carga de imagen de Avatar procesada correctamente')
      yield put({
        type: actions.BIBAVATARES_GALERIA_UPLOAD_IMAGE_SUCCEEDED,
        payload: bibAvataresObjetoVar.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al procesar la carga de imagen de Avatar')
      yield put({
        type: actions.BIBAVATARES_GALERIA_UPLOAD_IMAGE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al procesar la carga de imagen de Avatar')
    yield all([
      put({
        type: actions.BIBAVATARES_GALERIA_UPLOAD_IMAGE_FAILED,
        error: e.message,
      }),
    ])
  }
}

// Plantillas personalizadas
export function* GET_BIBAVATARES_PLANTILLA() {
  try {
    const bibliotecasAvataresPlantillaData = yield call(getBibliotecasAvataresPlantillas)
    if (bibliotecasAvataresPlantillaData.ok) {
      yield put({
        type: actions.BIBAVATARES_PLANTILLA_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresPlantillaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Plantillas Personalizadas')
      put({
        type: actions.BIBAVATARES_PLANTILLA_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Plantillas Personalizadas')
    yield all([
      put({
        type: actions.BIBAVATARES_PLANTILLA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_PLANTILLA_BY_ID(action) {
  try {
    const bibliotecasAvataresPlantillaData = yield call(
      getBibliotecasAvataresPlantillaById,
      action.payload,
    )
    if (bibliotecasAvataresPlantillaData.ok) {
      yield put({
        type: actions.BIBAVATARES_PLANTILLA_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresPlantillaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Plantillas Personalizadas')
      put({
        type: actions.BIBAVATARES_PLANTILLA_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Plantillas Personalizadas')
    yield all([
      put({
        type: actions.BIBAVATARES_PLANTILLA_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_PLANTILLA(action) {
  try {
    const bibAvataresPlantilla = yield call(insertBibliotecaAvataresPlantilla, action.payload)
    if (bibAvataresPlantilla.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Paletas creada correctamente')
      history.push(`/avatares/plantilla/edit/${bibAvataresPlantilla.data.id}`)
    } else {
      putMessage(messageType.ERROR, 'Error al crear la Biblioteca de Plantilla Personalizada')
      yield put({
        type: actions.BIBAVATARES_PLANTILLA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear la Biblioteca de Plantilla Personalizada')
    yield all([
      put({
        type: actions.BIBAVATARES_PLANTILLA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_PLANTILLA(action) {
  try {
    const bibAvataresPlantilla = yield call(updateBibliotecaAvataresPlantilla, action.payload)
    if (bibAvataresPlantilla.ok) {
      putMessage(
        messageType.SUCCESS,
        'Biblioteca de Plantilla Personalizada modificada correctamente',
      )
      yield put({
        type: actions.BIBAVATARES_PLANTILLA_UPDATE_SUCCEEDED,
        payload: bibAvataresPlantilla.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar la Biblioteca de Plantilla Personalizada')
      yield put({
        type: actions.BIBAVATARES_PLANTILLA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar la Biblioteca de Plantilla Personalizada')
    yield all([
      put({
        type: actions.BIBAVATARES_PLANTILLA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_PLANTILLA(action) {
  try {
    const bibAvataresPlantilla = yield call(deleteBibliotecaAvataresPlantilla, action.payload)
    if (bibAvataresPlantilla.ok) {
      putMessage(
        messageType.SUCCESS,
        'Biblioteca de Plantilla Personalizada eliminada correctamente',
      )
      yield put({
        type: actions.DELETE_BIBAVATARES_PLANTILLA_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Plantilla Personalizada')
      put({
        type: actions.DELETE_BIBAVATARES_PLANTILLA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Plantilla Personalizada')
    yield all([
      put({
        type: actions.DELETE_BIBAVATARES_PLANTILLA_FAILED,
        error: e.message,
      }),
    ])
  }
}

// Plantillas personalizadas -> Objetos
export function* GET_BIBAVATARES_PLANTILLA_OBJETOS(action) {
  try {
    const bibliotecasAvataresPlantillaObjData = yield call(
      getBibliotecasAvataresPlantillaObjetos,
      action.payload,
    )
    if (bibliotecasAvataresPlantillaObjData.ok) {
      yield put({
        type: actions.BIBAVATARES_PLANTILLA_OBJETOS_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresPlantillaObjData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Objetos de Plantilla')
      put({
        type: actions.BIBAVATARES_PLANTILLA_OBJETOS_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Objetos de Plantilla')
    yield all([
      put({
        type: actions.BIBAVATARES_PLANTILLA_OBJETOS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_PLANTILLA_OBJETOS_BY_ID(action) {
  try {
    const bibliotecasAvataresPlantillaObjData = yield call(
      getBibliotecasAvataresPlantillaObjetoById,
      action.payload,
    )
    if (bibliotecasAvataresPlantillaObjData.ok) {
      yield put({
        type: actions.BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresPlantillaObjData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Objeto Personalizado')
      put({
        type: actions.BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de Objeto Personalizado')
    yield all([
      put({
        type: actions.BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

// Layers
export function* GET_BIBAVATARES_LAYERS(action) {
  try {
    const bibliotecasAvataresLayerData = yield call(getBibliotecasAvataresLayers, action.payload)
    if (bibliotecasAvataresLayerData.ok) {
      yield put({
        type: actions.BIBAVATARES_LAYER_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresLayerData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Capas')
      put({
        type: actions.BIBAVATARES_LAYER_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Capas')
    yield all([
      put({
        type: actions.BIBAVATARES_LAYER_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_LAYER_BY_ID(action) {
  try {
    const bibliotecasAvataresLayerData = yield call(getBibliotecasAvataresLayerById, action.payload)
    if (bibliotecasAvataresLayerData.ok) {
      yield put({
        type: actions.BIBAVATARES_LAYER_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresLayerData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Capas')
      put({
        type: actions.BIBAVATARES_LAYER_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Capas')
    yield all([
      put({
        type: actions.BIBAVATARES_LAYER_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_LAYER(action) {
  try {
    const bibAvataresLayer = yield call(insertBibliotecaAvataresLayer, action.payload)
    if (bibAvataresLayer.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Capas modificada correctamente')
      yield put({
        type: actions.BIBAVATARES_LAYER_INSERT_SUCCEEDED,
        payload: bibAvataresLayer.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Biblioteca de Capas')
      yield put({
        type: actions.BIBAVATARES_LAYER_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Biblioteca de Capas')
    yield all([
      put({
        type: actions.BIBAVATARES_LAYER_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_LAYER(action) {
  try {
    const bibAvataresLayer = yield call(updateBibliotecaAvataresLayer, action.payload)
    if (bibAvataresLayer.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Capas modificada correctamente')
      yield put({
        type: actions.BIBAVATARES_LAYER_UPDATE_SUCCEEDED,
        payload: bibAvataresLayer.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Capas')
      yield put({
        type: actions.BIBAVATARES_LAYER_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Capas')
    yield all([
      put({
        type: actions.BIBAVATARES_LAYER_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_LAYER(action) {
  try {
    const bibAvataresLayer = yield call(deleteBibliotecaAvataresLayer, action.payload)
    if (bibAvataresLayer.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Capas eliminada correctamente')
      yield put({
        type: actions.DELETE_BIBAVATARES_LAYER_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Capas')
      put({
        type: actions.DELETE_BIBAVATARES_LAYER_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Capas')
    yield all([
      put({
        type: actions.DELETE_BIBAVATARES_LAYER_FAILED,
        error: e.message,
      }),
    ])
  }
}

// Colores
export function* GET_BIBAVATARES_COLORES(action) {
  try {
    const bibliotecasAvataresColorData = yield call(getBibliotecasAvataresColor, action.payload)
    if (bibliotecasAvataresColorData.ok) {
      yield put({
        type: actions.BIBAVATARES_COLOR_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresColorData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Colores')
      put({
        type: actions.BIBAVATARES_COLOR_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Colores')
    yield all([
      put({
        type: actions.BIBAVATARES_COLOR_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_COLOR(action) {
  try {
    const bibAvataresColor = yield call(insertBibliotecaAvataresColor, action.payload)
    if (bibAvataresColor.ok) {
      putMessage(messageType.SUCCESS, 'Color creado correctamente')
      yield put({
        type: actions.BIBAVATARES_COLOR_INSERT_SUCCEEDED,
        payload: bibAvataresColor.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear el Color')
      yield put({
        type: actions.BIBAVATARES_COLOR_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear el Color')
    yield all([
      put({
        type: actions.BIBAVATARES_COLOR_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_COLOR(action) {
  try {
    const bibAvataresColor = yield call(updateBibliotecaAvataresColor, action.payload)
    if (bibAvataresColor.ok) {
      putMessage(messageType.SUCCESS, 'Color modificado correctamente')
      yield put({
        type: actions.BIBAVATARES_COLOR_UPDATE_SUCCEEDED,
        payload: bibAvataresColor.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el Color')
      yield put({
        type: actions.BIBAVATARES_COLOR_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el Color')
    yield all([
      put({
        type: actions.BIBAVATARES_COLOR_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_COLOR(action) {
  try {
    const bibAvataresColor = yield call(deleteBibliotecaAvataresColor, action.payload)
    if (bibAvataresColor.ok) {
      putMessage(messageType.SUCCESS, 'Color eliminado correctamente')
      yield put({
        type: actions.DELETE_BIBAVATARES_COLOR_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar el Color')
      put({
        type: actions.DELETE_BIBAVATARES_COLOR_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar el Color')
    yield all([
      put({
        type: actions.DELETE_BIBAVATARES_COLOR_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_COLOR_ORDER(action) {
  try {
    const dataResult = yield call(updateBibliotecaAvataresColorOrder, action.payload)
    if (dataResult.ok) {
      putMessage(messageType.SUCCESS, 'Orden de color modificado correctamente')
      yield put({
        type: actions.BIBAVATARES_COLOR_UPDATE_ORDER_SUCCEEDED,
        payload: dataResult.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el orden del color')
      yield put({
        type: actions.BIBAVATARES_COLOR_UPDATE_ORDER_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el orden del color')
    yield all([
      put({
        type: actions.BIBAVATARES_COLOR_UPDATE_ORDER_FAILED,
        error: e.message,
      }),
    ])
  }
}

// Avatares por producto
export function* GET_BIBAVATARES_PROD_BY_ID(action) {
  try {
    const bibliotecasAvataresProdData = yield call(getBibliotecasAvataresProdById, action.payload)
    if (bibliotecasAvataresProdData.ok) {
      yield put({
        type: actions.BIBAVATARES_PROD_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresProdData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los avatares de producto')
      put({
        type: actions.BIBAVATARES_PROD_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar los avatares de producto')
    yield all([
      put({
        type: actions.BIBAVATARES_PROD_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

// Piezas de avatares
export function* GET_BIBAVATARES_PIEZAS(action) {
  try {
    const bibliotecasAvataresPiezasData = yield call(getBibliotecasAvataresPiezas, action.payload)
    if (bibliotecasAvataresPiezasData.ok) {
      yield put({
        type: actions.BIBAVATARES_PIEZA_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresPiezasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Piezas')
      put({
        type: actions.BIBAVATARES_PIEZA_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Piezas')
    yield all([
      put({
        type: actions.BIBAVATARES_PIEZA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBAVATARES_PIEZA_BY_ID(action) {
  try {
    const bibliotecasAvataresPiezaData = yield call(getBibliotecasAvataresPiezaById, action.payload)
    if (bibliotecasAvataresPiezaData.ok) {
      yield put({
        type: actions.BIBAVATARES_PIEZA_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasAvataresPiezaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Piezas')
      put({
        type: actions.BIBAVATARES_PIEZA_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Piezas')
    yield all([
      put({
        type: actions.BIBAVATARES_PIEZA_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBAVATARES_PIEZA(action) {
  try {
    const bibAvataresPieza = yield call(insertBibliotecaAvataresPieza, action.payload)
    if (bibAvataresPieza.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Piezas modificada correctamente')
      yield put({
        type: actions.BIBAVATARES_PIEZA_INSERT_SUCCEEDED,
        payload: bibAvataresPieza.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Biblioteca de Piezas')
      yield put({
        type: actions.BIBAVATARES_PIEZA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Biblioteca de Piezas')
    yield all([
      put({
        type: actions.BIBAVATARES_PIEZA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBAVATARES_PIEZA(action) {
  try {
    const bibAvataresPieza = yield call(updateBibliotecaAvataresPieza, action.payload)
    if (bibAvataresPieza.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Piezas modificada correctamente')
      yield put({
        type: actions.BIBAVATARES_PIEZA_UPDATE_SUCCEEDED,
        payload: bibAvataresPieza.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Piezas')
      yield put({
        type: actions.BIBAVATARES_PIEZA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Piezas')
    yield all([
      put({
        type: actions.BIBAVATARES_PIEZA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBAVATARES_PIEZA(action) {
  try {
    const bibAvataresPieza = yield call(deleteBibliotecaAvataresPieza, action.payload)
    if (bibAvataresPieza.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Piezas eliminada correctamente')
      yield put({
        type: actions.DELETE_BIBAVATARES_PIEZA_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Piezas')
      put({
        type: actions.DELETE_BIBAVATARES_PIEZA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Biblioteca de Piezas')
    yield all([
      put({
        type: actions.DELETE_BIBAVATARES_PIEZA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.BIBAVATARES_LOAD_REQUESTED, GET_BIBAVATARES),
    takeEvery(actions.BIBAVATARES_BYID_LOAD_REQUESTED, GET_BIBAVATARES_BY_ID),
    takeEvery(actions.BIBAVATARES_INSERT_REQUESTED, INSERT_BIBAVATARES),
    takeEvery(actions.BIBAVATARES_UPDATE_REQUESTED, UPDATE_BIBAVATARES),
    takeEvery(actions.DELETE_BIBAVATARES_REQUESTED, DELETE_BIBAVATARES),
    takeEvery(actions.BIBAVATARES_MODELO_BYID_LOAD_REQUESTED, GET_BIBAVATARES_MODELO_BY_ID),
    takeEvery(actions.BIBAVATARES_SECCION_LOAD_REQUESTED, GET_BIBAVATARES_SECCION),
    takeEvery(actions.BIBAVATARES_SECCION_BYID_LOAD_REQUESTED, GET_BIBAVATARES_SECCION_BY_ID),
    takeEvery(actions.BIBAVATARES_SECCION_INSERT_REQUESTED, INSERT_BIBAVATARES_SECCION),
    takeEvery(actions.BIBAVATARES_SECCION_UPDATE_REQUESTED, UPDATE_BIBAVATARES_SECCION),
    takeEvery(actions.DELETE_BIBAVATARES_SECCION_REQUESTED, DELETE_BIBAVATARES_SECCION),
    takeEvery(actions.BIBAVATARES_SECCION_UPDATE_ORDER_REQUESTED, UPDATE_BIBAVATARES_SECCION_ORDER),
    takeEvery(actions.BIBAVATARES_PALETA_LOAD_REQUESTED, GET_BIBAVATARES_PALETA),
    takeEvery(actions.BIBAVATARES_PALETA_BYID_LOAD_REQUESTED, GET_BIBAVATARES_PALETA_BY_ID),
    takeEvery(actions.BIBAVATARES_PALETA_INSERT_REQUESTED, INSERT_BIBAVATARES_PALETA),
    takeEvery(actions.BIBAVATARES_PALETA_UPDATE_REQUESTED, UPDATE_BIBAVATARES_PALETA),
    takeEvery(actions.DELETE_BIBAVATARES_PALETA_REQUESTED, DELETE_BIBAVATARES_PALETA),
    takeEvery(actions.BIBAVATARES_PALETA_DUPLICAR_REQUESTED, DUPLICAR_BIBAVATARES_PALETA),
    takeEvery(actions.BIBAVATARES_SIZE_LOAD_REQUESTED, GET_BIBAVATARES_SIZE),
    takeEvery(actions.BIBAVATARES_SIZEFAM_LOAD_REQUESTED, GET_BIBAVATARES_SIZEFAM),
    takeEvery(actions.BIBAVATARES_SIZE_BYID_LOAD_REQUESTED, GET_BIBAVATARES_SIZE_BY_ID),
    takeEvery(actions.BIBAVATARES_SIZE_INSERT_REQUESTED, INSERT_BIBAVATARES_SIZE),
    takeEvery(actions.BIBAVATARES_SIZE_UPDATE_REQUESTED, UPDATE_BIBAVATARES_SIZE),
    takeEvery(actions.DELETE_BIBAVATARES_SIZE_REQUESTED, DELETE_BIBAVATARES_SIZE),
    takeEvery(actions.BIBAVATARES_CLIENTE_RESUME_LOAD_REQUESTED, GET_BIBAVATARES_CLIENTE_RESUME),
    takeEvery(actions.BIBAVATARES_CLIENTE_ADMIN_LOAD_REQUESTED, GET_BIBAVATARES_CLIENTE_ADMIN),
    takeEvery(actions.BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_REQUESTED, GET_BIBAVATARES_CLIENTE_EMAIL_ADMIN),
    takeEvery(actions.BIBAVATARES_GALERIA_LOAD_REQUESTED, GET_BIBAVATARES_GALERIA),
    takeEvery(actions.BIBAVATARES_OBJETO_BYID_LOAD_REQUESTED, GET_BIBAVATARES_OBJETO_BY_ID),
    takeEvery(
      actions.BIBAVATARES_OBJETO_UNICO_BYID_LOAD_REQUESTED,
      GET_BIBAVATARES_OBJETO_UNICO_BY_ID,
    ),
    takeEvery(actions.BIBAVATARES_OBJETO_UNICO_UPDATE_REQUESTED, UPDATE_BIBAVATARES_OBJETO_UNICO),
    takeEvery(
      actions.BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_REQUESTED,
      GET_BIBAVATARES_OBJETO_VARIANTE_BY_ID,
    ),
    takeEvery(actions.BIBAVATARES_CACHE_CLIENTE_UPDATE_REQUESTED, UPDATE_BIBAVATARES_CACHE_CLIENTE),
    takeEvery(actions.BIBAVATARES_CACHE_ADMIN_UPDATE_REQUESTED, UPDATE_BIBAVATARES_CACHE_ADMIN),
    takeEvery(
      actions.BIBAVATARES_CACHE_FAMILIAS_UPDATE_REQUESTED,
      UPDATE_BIBAVATARES_CACHE_FAMILIAS,
    ),
    takeEvery(
      actions.BIBAVATARES_CACHE_PRODUCTOS_UPDATE_REQUESTED,
      UPDATE_BIBAVATARES_CACHE_PRODUCTOS,
    ),
    takeEvery(actions.BIBAVATARES_CACHE_PAISES_UPDATE_REQUESTED, UPDATE_BIBAVATARES_CACHE_PAISES),
    takeEvery(
      actions.BIBAVATARES_CACHE_PROVINCIAS_UPDATE_REQUESTED,
      UPDATE_BIBAVATARES_CACHE_PROVINCIAS,
    ),
    takeEvery(actions.BIBAVATARES_GALERIA_MASIVO_REQUESTED, UPLOAD_BIBAVATARES_GALERIA_MASIVO),
    takeEvery(
      actions.BIBAVATARES_GALERIA_CONFIRM_MASIVO_REQUESTED,
      CONFIRM_BIBAVATARES_GALERIA_MASIVO,
    ),
    takeEvery(actions.BIBAVATARES_GALERIA_UPLOAD_IMAGE_REQUESTED, INSERT_BIBAVATARES_GALERIA_FILE),
    takeEvery(actions.BIBAVATARES_PLANTILLA_LOAD_REQUESTED, GET_BIBAVATARES_PLANTILLA),
    takeEvery(actions.BIBAVATARES_PLANTILLA_BYID_LOAD_REQUESTED, GET_BIBAVATARES_PLANTILLA_BY_ID),
    takeEvery(actions.BIBAVATARES_PLANTILLA_INSERT_REQUESTED, INSERT_BIBAVATARES_PLANTILLA),
    takeEvery(actions.BIBAVATARES_PLANTILLA_UPDATE_REQUESTED, UPDATE_BIBAVATARES_PLANTILLA),
    takeEvery(actions.DELETE_BIBAVATARES_PLANTILLA_REQUESTED, DELETE_BIBAVATARES_PLANTILLA),
    takeEvery(
      actions.BIBAVATARES_PLANTILLA_OBJETOS_LOAD_REQUESTED,
      GET_BIBAVATARES_PLANTILLA_OBJETOS,
    ),
    takeEvery(
      actions.BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_REQUESTED,
      GET_BIBAVATARES_PLANTILLA_OBJETOS_BY_ID,
    ),
    takeEvery(actions.BIBAVATARES_OBJETO_UPDATE_REQUESTED, UPDATE_BIBAVATARES_OBJETO),
    takeEvery(actions.BIBAVATARES_LAYER_LOAD_REQUESTED, GET_BIBAVATARES_LAYERS),
    takeEvery(actions.BIBAVATARES_LAYER_BYID_LOAD_REQUESTED, GET_BIBAVATARES_LAYER_BY_ID),
    takeEvery(actions.BIBAVATARES_LAYER_INSERT_REQUESTED, INSERT_BIBAVATARES_LAYER),
    takeEvery(actions.BIBAVATARES_LAYER_UPDATE_REQUESTED, UPDATE_BIBAVATARES_LAYER),
    takeEvery(actions.DELETE_BIBAVATARES_LAYER_REQUESTED, DELETE_BIBAVATARES_LAYER),
    takeEvery(actions.BIBAVATARES_COLOR_LOAD_REQUESTED, GET_BIBAVATARES_COLORES),
    takeEvery(actions.BIBAVATARES_COLOR_INSERT_REQUESTED, INSERT_BIBAVATARES_COLOR),
    takeEvery(actions.BIBAVATARES_COLOR_UPDATE_REQUESTED, UPDATE_BIBAVATARES_COLOR),
    takeEvery(actions.DELETE_BIBAVATARES_COLOR_REQUESTED, DELETE_BIBAVATARES_COLOR),
    takeEvery(actions.BIBAVATARES_COLOR_UPDATE_ORDER_REQUESTED, UPDATE_BIBAVATARES_COLOR_ORDER),
    takeEvery(actions.BIBAVATARES_PROD_BYID_LOAD_REQUESTED, GET_BIBAVATARES_PROD_BY_ID),
    takeEvery(actions.BIBAVATARES_PIEZA_LOAD_REQUESTED, GET_BIBAVATARES_PIEZAS),
    takeEvery(actions.BIBAVATARES_PIEZA_BYID_LOAD_REQUESTED, GET_BIBAVATARES_PIEZA_BY_ID),
    takeEvery(actions.BIBAVATARES_PIEZA_INSERT_REQUESTED, INSERT_BIBAVATARES_PIEZA),
    takeEvery(actions.BIBAVATARES_PIEZA_UPDATE_REQUESTED, UPDATE_BIBAVATARES_PIEZA),
    takeEvery(actions.DELETE_BIBAVATARES_PIEZA_REQUESTED, DELETE_BIBAVATARES_PIEZA),
    takeEvery(
      actions.BIBAVATARES_OBJETO_INSERT_MINIATURA_REQUESTED,
      INSERT_BIBAVATARES_OBJETO_MINIATURA,
    ),
    takeEvery(
      actions.BIBAVATARES_OBJETO_DELETE_MINIATURA_REQUESTED,
      DELETE_BIBAVATARES_OBJETO_MINIATURA,
    ),
    takeEvery(
      actions.BIBAVATARES_OBJETO_INSERT_IMPRESION_REQUESTED,
      INSERT_BIBAVATARES_OBJETO_IMPRESION,
    ),
    takeEvery(
      actions.BIBAVATARES_OBJETO_DELETE_IMPRESION_REQUESTED,
      DELETE_BIBAVATARES_OBJETO_IMPRESION,
    ),
    takeEvery(
      actions.BIBAVATARES_OBJETO_INSERT_VARIANTE_REQUESTED,
      INSERT_BIBAVATARES_OBJETO_VARIANTE,
    ),
    takeEvery(
      actions.BIBAVATARES_OBJETO_DELETE_VARIANTE_REQUESTED,
      DELETE_BIBAVATARES_OBJETO_VARIANTE,
    ),
    takeEvery(
      actions.BIBAVATARES_OBJETO_VARIANTE_SIZE_REQUESTED,
      UPDATE_BIBAVATARES_OBJETO_VARIANTE_SIZE,
    ),
    takeEvery(
      actions.BIBAVATARES_OBJETO_VARIANTE_UPDATE_REQUESTED,
      UPDATE_BIBAVATARES_OBJETO_VARIANTE,
    ),
  ])
}
